<template>
  <b-modal
    id="UserDisableError"
    centered
    size="lg"
    ref="UserDisableErrorModal"
    class="modal-backdrop"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template slot="modal-header" class="mx-auto">
      <h5 class="modal-title" style="text-align:center;">{{headerMessage}}</h5>
    </template>
    <template slot="default">
      <p style="background-color:#fae5e3;">
        <span v-html="message"></span>
      </p>
      <p>
        <span v-html="$store.getters.errorMessage"></span>
      </p>
    </template>

    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button class="um-btn" @click="onClose()">Close</b-button>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "UserDisableError",

  data() {
    return {};
  },

  props: {
    headerMessage: String,
    message: String
  },
  methods: {
    onClose: function() {
        this.$bvModal.hide("activateuser");
        this.$bvModal.hide("UserDisableError");
    }
  }
};
</script>
<style>
.requiredinput {
  color: red;
}

.hasError label {
  color: red !important;
}

.hasError input {
  border-color: red !important;
}

.noError input {
  border-color: white !important;
}

.modal-backdrop {
  opacity: 0.5;
  transition: opacity 0.2s;
  border-color: red;
}

.modal-title {
  margin: auto;
}

.errorMessage {
  color: red;
  font-size: 0.8em;
  font-weight: 500;
}
</style>
